import { render, staticRenderFns } from "./increase-your-energy-a45.vue?vue&type=template&id=6fc31890"
import script from "./increase-your-energy-a45.vue?vue&type=script&lang=js"
export * from "./increase-your-energy-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports